import { PaperBlock } from './paper-block'
import { Quiz } from './quiz'

export interface QuizBlockQuestionInterface {
  blocks?: PaperBlock[]
  quiz?: Quiz
}

export class QuizBlockQuestion implements QuizBlockQuestionInterface {
  blocks?: PaperBlock[]
  quiz?: Quiz

  constructor(props: QuizBlockQuestionInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      blocks: _blocks,
      quiz: _quiz,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.blocks = _blocks ? _blocks.map((i) => new PaperBlock(i)) : _blocks
    this.quiz = _quiz ? new Quiz(_quiz) : _quiz
  }
}
